import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiRouterService } from '../http/api.router';
import { BaseHttpService } from '../http/base.http.service';

@Injectable({
  providedIn: 'root'
})
export class TemporalPassesHttpService extends BaseHttpService {

  private baseURL = `passes`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  private buildQuery(params: { page?: number; size?: number; name?: string; fareIds?: number[] }): string {
    const parts: string[] = [];
    if (params.page !== undefined) parts.push(`page=${params.page}`);
    if (params.size !== undefined) parts.push(`size=${params.size}`);
    if (params.name !== undefined && params.name !== '') parts.push(`name=${encodeURIComponent(params.name)}`);
    if (params.fareIds !== undefined && params.fareIds.length > 0) {
      parts.push(`fareIds=${params.fareIds.join(',')}`);
    }
    return parts.length > 0 ? `?${parts.join('&')}` : '';
  }

  public getTemporalPasses(page?: number, size?: number, name?: string, fareIds?: number[]) {
    const query = this.buildQuery({ page, size, name, fareIds });
    const url = this.routerService.mount(`${this.baseURL}${query}`);
    return this.read(url);
  }

  public getTemporalPass(id: number) {
    const url = this.routerService.mount(`${this.baseURL}/${id}`);
    return this.read(url);
  }

  public createTemporalPass(body: any) {
    const url = this.routerService.mount(this.baseURL);
    return this.create(body, url);
  }

  public updateTemporalPass(id: number, body: any) {
    const url = this.routerService.mount(`${this.baseURL}/${id}`);
    return this.update(body, url);
  }

  public deactivateTemporalPass(id: number) {
    const url = this.routerService.mount(`${this.baseURL}/${id}/deactivate`);
    return this.update({}, url);
  }

  public activateTemporalPass(id: number) {
    const url = this.routerService.mount(`${this.baseURL}/${id}/activate`);
    return this.update({}, url);
  }
}
